import(/* webpackMode: "eager", webpackExports: ["SignUpForm"] */ "/vercel/path0/src/app/auth/signup/signup-form.tsx");
